import React from "react";
import { commitHash, deploymentNumber, lastLog } from "../modules/Common/last_log";

export function StagTest() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Deployment Status</h2>
      <div style={{ marginBottom: "20px" }}>
        <b>App:</b> tenant-client
      </div>
      <div style={{ marginBottom: "20px" }}>
        <b>Deployment Number:</b> {deploymentNumber || "unknown"}
      </div>
      <div style={{ marginBottom: "20px" }}>
        <b>Commit Hash:</b> {commitHash || "unknown"}
      </div>
      <div style={{ marginBottom: "20px" }}>
        <b>Last Log</b>
        <pre className="ml-20" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          {lastLog || "No log available"}
        </pre>
      </div>
    </div>
  );
}
